import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FileUploadUI from './FileUploadUI';
import { callWebHook } from './webhook';

function FileUploader({ useremail , uploadOption}) {
  const fileInput = React.useRef();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  function generateId() {
    return `id-${Math.random().toString(36).substr(2, 9)}`;
  }
  useEffect(() => {
    if (loading) {
      document.title = `(${progress}%)...`;
    } else {
      document.title = 'Giving';      
    }
  }, [loading, progress]);

  const uploadFile = async () => {  // Adjust this line to take the category as a parameter
    function resetBar() {
      setLoading(false);
      setProgress(100);
      setTimeout(() => {
        setProgress(0);
        document.title = 'Giving';
      }, 1000);  // Reset progress bar and title after 1 second
    }
    setLoading(true);
    const file = fileInput.current.files[0];
    const fileName = file.name;
    const fileType = file.type;

    let client_type = `Generic_${uploadOption}_inputs`

    const lowerFileName = fileName.toLowerCase();

    // New logic for client_type
    if (lowerFileName.includes('rmhc')) {
      client_type = `RMHC_${uploadOption}_inputs`;
    } else if (lowerFileName.includes('transformed')) {
      setLoading(false);
      throw new Error('"transformed" can\'t be included in upload filenames.');
    }
    console.log(client_type);
    const totalSize = file.size;

    // console.log("file size: ", totalSize )
    
    //const url = 'https://7325rhuwzf.execute-api.us-east-2.amazonaws.com/Prod/upload'
    const url = process.env.REACT_APP_UPLOAD_API_URL_MAIN;
    const ETL_WAIT_TIMEOUT = isNaN(Number(process.env.ETL_WAIT_TIMEOUT)) ? 3 : Number(process.env.ETL_WAIT_TIMEOUT);
    console.log(url);
    const uploadId = generateId();
    console.log(`uploadId: ${uploadId}`);

    const decoratedFileName = `${uploadId}__${lowerFileName}`

    // alert(useremail)
    
    const response = await axios({
      method: 'GET',
      url: url,
      params: {
        file_name: decoratedFileName,
        email: useremail,
        file_type: fileType,
        client_type: client_type,
        upload_option: uploadOption
      }
    });
    const presignedPostData = response.data;

    const key = presignedPostData.fields['key']

    console.log('url : ' + presignedPostData.url);
    console.log('key: ' + key);

    const formData = new FormData();

    Object.keys(presignedPostData.fields).forEach(key => {
      // console.log('key: ' + key + ' value: ' + presignedPostData.fields[key]); 

      formData.append(key, presignedPostData.fields[key]);
    });

    formData.append('file', file);
    try {
      const results = await axios({
        method: 'post',
        url: presignedPostData.url,
        data: formData,
        // headers: {
        //   'Content-Type': 'multipart/form-data',
          
        // },
        onUploadProgress: function(progressEvent) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / totalSize);
          setProgress(percentCompleted);
        },
      });
      // File uploaded successfully
      // Update webhook for pending status
      
    } catch (error) {
      console.error(`There was an error with the upload: ${error.message}`);
      throw error;
    }
    await callWebHook(uploadId, 'put', 'pending')
    // Monitor ETL process
    // ETL_WAIT_TIMEOUT is multiplied by 12 to calculate the total wait time in minutes, with a 5-second interval.
    for (let i=0; i < ETL_WAIT_TIMEOUT * 12; i++) {
      // Check ETL status
        let jsonData = await callWebHook(uploadId, 'get');
        if (!['pending', 'error'].includes(jsonData.status)) {
          break;
        } else if (jsonData.status === 'error') {
          resetBar();
          await callWebHook(uploadId, 'delete');
          throw new Error(`ETL processing error occured: ${jsonData.message}`);
        } else if ((ETL_WAIT_TIMEOUT * 12) - 1 == i) {
          resetBar();
          await callWebHook(uploadId, 'delete');
          throw new Error('ETL status monitoring timeout reached...');
        }
      // 5-second delay
      await new Promise(resolve => setTimeout(resolve, 5000)); // 5-second delay
    }
    resetBar();
    await callWebHook(uploadId, 'delete');
  }

  return <FileUploadUI fileInput={fileInput} loading={loading} uploadFile={uploadFile} progress={progress} uploadOption={uploadOption} />;
}

export default FileUploader;
